import BlueprintReducer from './BlueprintReducer.js';
import Constants from '../Constants.js';
import Rsrc from '../rsrc/Rsrc.js';
import Rsrcs from '../rsrc/Rsrcs.js';
const {
  getBlueprint,
  getStatus,
  getError
} = BlueprintReducer;
const {
  BLUEPRINT_STATUS,
  BLUEPRINT_GET
} = Constants;
class Blueprint {
  constructor(projectId, id) {
    this.projectId = projectId || process?.env?.projectId;
    this.id = id;
  }
  createAction(method, status, func) {
    return (dispatch, getState, opts) => {
      const projectId = this.projectId || opts && opts.api && opts.api.projectId;
      dispatch({
        type: BLUEPRINT_STATUS,
        status,
        projectId
      });
      return func(dispatch, getState, opts, projectId).catch(error => {
        dispatch({
          type: BLUEPRINT_STATUS,
          projectId,
          status: `${method}Error`,
          error
        });
        return Promise.reject(error);
      });
    };
  }
  get(opts) {
    return this.createAction('load', 'loading', async (dispatch, getState, {
      api
    }, projectId = this.projectId) => {
      let getBlueprintReq;
      if (projectId) {
        getBlueprintReq = api.project(projectId).blueprints().get(this.id, opts);
      } else {
        getBlueprintReq = api.blueprint(this.id).get(opts);
      }
      const r = await getBlueprintReq;
      dispatch({
        type: BLUEPRINT_GET,
        projectId,
        blueprint: r
      });
      return r;
    });
  }
  getRsrcApi = (dispatch, getState, opts) => {
    const {
      api
    } = opts;
    if (!this.projectId) {
      return api.blueprint(this.id);
    }
    return api.project(this.projectId).blueprint(this.id);
  };
  resource(path) {
    return new Rsrc({
      ownerId: this.id,
      coownerId: null,
      path,
      resourceApi: this.getRsrcApi
    });
  }
  resources() {
    return new Rsrcs({
      ownerId: this.id,
      coownerId: null,
      resourceApi: this.getRsrcApi
    });
  }
  getStatus(state) {
    return getStatus(state, this.projectId, this.id);
  }
  getError(state) {
    return getError(state, this.projectId, this.id);
  }
  getBlueprint(state) {
    return getBlueprint(state, this.projectId, this.id);
  }
}
export default Blueprint;